//import hooks

//import components
import Header from "./Header";
import CardList1 from "./CardList1";
import CardList2 from "./CardList2";
import CardList3 from "./CardList3";
import PastProductsList from "./PastProductsList";
import ClientsOpinions from "./ClientsOpinions";
import CommonQuestions from "./CommonQuestions";

// import static files
import cardListData from "../../utils/data/cardListData";

const Main = () => {
    return (
        <div className="full-page-content">
            <Header />
            <main>
                {cardListData.map((list) => {
                    return list.listStyle == 1 ? (
                        <CardList1 list={list} />
                    ) : list.listStyle == 2 ? (
                        <CardList2 list={list} />
                    ) : (
                        <CardList3 list={list} />
                    );
                })}
                <PastProductsList />
                <ClientsOpinions />
                <CommonQuestions />
            </main>
        </div>
    );
};

export default Main;
